/**
 * Created by oreuveni
 * Date: 2019-04-17
 * Time: 17:48
 */
export const BID_STRATEGIES = {
    SMART: 'SMART',
    FIXED: 'FIXED',
    TARGET_CPA: 'TARGET_CPA',
    MAX_CONVERSIONS: 'MAX_CONVERSIONS',
    MAX_VALUE: 'MAX_VALUE',
    TARGET_ROAS: 'TARGET_ROAS',
    BID_MODIFIER: 'BID_MODIFIER',
};

export default BID_STRATEGIES;
